import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import LandingPage from '../../components/PageStructure/LandingPage/LandingPage';

import globals from '../../globals/communityGlobals';

const locale = globals.getArea('accountLogin');

class SignIn extends React.Component {
  componentDidMount = () => {
    document.title = this.props.pageTitle;
  };

  onLogoutButtonClick = event => {
    event.preventDefault();
    localStorage.setItem('access_token', null);
    this.props.logoutAndRedirect();
  };

  reloadPage = () => {
    location.reload();
  };

  notLoggedIn = () => <p>{locale.getMsg('loginMessage')}</p>;

  notAuthorized = () => {
    const { loginName, displayName } = this.props;

    return (
      <div>
        <p>{locale.getMsg('unauthorizedMessage')}</p>
        <p>{loginName && locale.getMsg('loggedUserInfo', [displayName, loginName])}</p>
        <button id="LoginButton" onClick={this.onLogoutButtonClick}>
          {locale.getMsg('logout')}
        </button>
      </div>
    );
  };

  logginIn = () => {
    const { loginName, displayName } = this.props;

    return (
      <div>
        <p>{loginName && locale.getMsg('loggedUserInfo', [displayName, loginName])}</p>
        <p>{locale.getMsg('loading')}</p>
      </div>
    );
  };

  render() {
    const { location, isFetching, notAuthorized, isAuthenticated, failure, success, isExpired } = this.props;
    const { from } = location.state || { from: { pathname: '/Planner' } };

    if (isAuthenticated) {
      return <Redirect to={from} />;
    }
    if (isExpired) {
      this.reloadPage();
    }
    return (
      <LandingPage>
        <h1>{locale.getMsg('login')}</h1>
        {success && success.length > 0 && <div className="login-success">{success}</div>}
        {failure && failure.length > 0 && <div className="login-error">{failure}</div>}
        {isFetching && this.logginIn()}
        {!isFetching && !notAuthorized && this.notLoggedIn()}
        {!isFetching && notAuthorized && this.notAuthorized()}
      </LandingPage>
    );
  }
}

SignIn.propTypes = {
  logoutAndRedirect: PropTypes.func.isRequired,
  isExpired: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  notAuthorized: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  failure: PropTypes.string,
  success: PropTypes.string,
  displayName: PropTypes.string,
  loginName: PropTypes.string,
  pageTitle: PropTypes.string.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    key: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.shape({
      from: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }),
  }),
};

SignIn.defaultProps = {
  failure: '',
  success: '',
  displayName: null,
  loginName: null,
  location: {},
};

export default SignIn;
